import EmblaCarousel from 'embla-carousel';
import Autoplay from 'embla-carousel-autoplay';
import Fade from 'embla-carousel-fade';
import ClassNames from 'embla-carousel-class-names';
import AutoScroll from 'embla-carousel-auto-scroll';
import Headroom from 'headroom.js';

document.addEventListener("DOMContentLoaded", function () {
    initSearchBar();
    const header = document.querySelector('.site-header');
    const headerHeight = header ? header.offsetHeight : 100;
    if (header) {
        const headroom = new Headroom(header, {
            offset: headerHeight,
            classes: {
                initial: 'headroom',
                pinned: 'headroom--pinned',
                unpinned: 'headroom--unpinned',
                top: 'headroom--top',
                notTop: 'headroom--not-top',
                bottom: 'headroom--bottom',
                notBottom: 'headroom--not-bottom',
            },
        });
        headroom.init();
    }

    const filterToggle = document.querySelector('.filter-toggle-btn');
    const catalogSidebar = document.querySelector('.sidebar.is-left-sidebar');
    // Add close button to sidebar
    if (catalogSidebar) {
        const closeBtn = document.createElement('button');
        closeBtn.classList.add('close-btn lg:!hidden');
        closeBtn.innerHTML = '<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="w-4"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M18 6l-12 12" /><path d="M6 6l12 12" /></svg>';
        closeBtn.addEventListener('click', function () {
            catalogSidebar.classList.remove('is-open');
        });
        catalogSidebar.insertBefore(closeBtn, catalogSidebar.firstChild);
    }
    if (filterToggle) {
        filterToggle.addEventListener('click', function () {
            catalogSidebar.classList.toggle('is-open');
        });
    }
    document.addEventListener('click', function (event) {
        if (catalogSidebar && !catalogSidebar.contains(event.target) && !filterToggle.contains(event.target)) {
            catalogSidebar.classList.remove('is-open');
        }
    });
    initTabs();
    const heroSlider = document.querySelector('.hero-slider');
    if (heroSlider) {
        initSlider(heroSlider, {
            loop: true,
            duration: 20,
            inViewThreshold: 0.5,
        },
            [
                Autoplay(),
                ClassNames(),
            ]
        );
    }

    const productSliders = document.querySelectorAll('.product-slider');
    if (productSliders.length > 0) {
        productSliders.forEach(function (slider) {
            initSlider(slider, {
                loop: true,
                duration: 40,
                slidesToScroll: 1,
                align: 'start',
            },
                [
                    Autoplay({
                        delay: 6000,
                    }),
                    ClassNames(),
                ]
            );
        });
    }
    const postSliders = document.querySelectorAll('.post-slider');
    if (postSliders.length > 0) {
        postSliders.forEach(function (slider) {
            initSlider(slider, {
                loop: true,
                duration: 40,
                slidesToScroll: 1,
                align: 'start',
            },
                [
                    Autoplay({
                        delay: 6000,
                    }),
                    ClassNames(),
                ]
            );
        });
    }
    const partnerSliders = document.querySelectorAll('.partner-slider');
    if (partnerSliders.length > 0) {
        partnerSliders.forEach(function (slider) {
            initSlider(slider, {
                loop: true,
                duration: 40,
                slidesToScroll: 1,
                align: 'end',
            },
                [
                    Autoplay({
                        delay: 6000,
                    }),
                    ClassNames(),
                    AutoScroll(),
                ]
            );
        });
    }

    const productImageSlider = document.querySelector('.product-images-slider');
    if (productImageSlider) {
        const productMainCarousel = initSlider(productImageSlider, {
            loop: false,
            slidesToScroll: 1,
            align: 'start',
        },
            [
                ClassNames(),
            ]
        );
    }
    const productThumbsSlider = document.querySelector('.product-thumbs-slider');
    if (productThumbsSlider) {
        const productThumbsCarousel = initSlider(productThumbsSlider, {
            loop: false,
            slidesToScroll: 1,
            //align: 'start',
            axis: 'y',
        },
            [
                ClassNames(),
            ]
        );
    }
});

function initSlider(element, options, plugins) {
    const viewportNode = element.querySelector('.embla__viewport');
    const prevButtonNode = element.querySelector('.embla__prev');
    const nextButtonNode = element.querySelector('.embla__next');
    const dotsNode = element.querySelector('.embla__dots')

    const embla = EmblaCarousel(viewportNode, options, plugins);

    if (prevButtonNode) {
        prevButtonNode.addEventListener('click', embla.scrollPrev, false);
    }
    if (nextButtonNode) {
        nextButtonNode.addEventListener('click', embla.scrollNext, false);
    }

    if (dotsNode) {
        const dots = Array.from(dotsNode.children);
        dots.forEach((dotNode, index) => {
            dotNode.addEventListener('click', () => embla.scrollTo(index), false);
        });
        embla.on('select', () => {
            const selectedDot = dots.find((dotNode, index) => index === embla.selectedScrollSnap());
            if (selectedDot) {
                dots.forEach(dotNode => dotNode.classList.remove('is-selected'));
                selectedDot.classList.add('is-selected');
            }
        }
        );
    }

    return embla;
}
function initTabs() {
    const tabsWrappers = document.querySelectorAll('.tabs-wrapper');

    tabsWrappers.forEach(function (container) {
        const tabLinks = container.querySelectorAll('.tab-link');
        const tabPanes = container.querySelectorAll('.tab-pane');

        tabLinks.forEach(function (link) {
            link.addEventListener('click', function (e) {
                e.preventDefault();

                // Remove active class from all links and panes within this container
                tabLinks.forEach(function (item) {
                    item.classList.remove('active');
                });

                tabPanes.forEach(function (pane) {
                    pane.classList.remove('active');
                });

                // Add active class to the clicked link and corresponding pane
                this.classList.add('active');
                const target = this.getAttribute('href');
                container.querySelector(target).classList.add('active');
            });
        });
    });
}

function initSearchBar() {
    const searchToggle = document.querySelector('.search-toggle-btn');
    const searchBar = document.getElementById('search-bar');
    const closeBtn = searchBar ? searchBar.querySelector('.close-btn') : null;
    if (searchToggle) {
        searchToggle.addEventListener('click', function (e) {
            e.preventDefault();
            if (searchBar) {
                searchBar.classList.toggle('is-open');
            }
        });
    }

    document.addEventListener('click', function (event) {
        if (searchBar && !searchBar.contains(event.target) && !searchToggle.contains(event.target)) {
            searchBar.classList.remove('is-open');
        }
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            searchBar.classList.remove('is-open');
        });
    }
}